// import axiosInstance from "axios";
import { axiosInstance } from "../../../@core/auth/jwt/jwtService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  freeCheckout: false,
  paymentsSupported: [],
  subscriptionsToCreate: [],
  customFieldsToCreate: [],
  customFieldsSelectOptions: [],
  checkoutSubscriptionStep: 1,
  checkoutSubscriptionCustomFields: 0,
  checkoutCustomFieldSelects: [],
  checkoutSubscriptionPrices: 0,
  checkoutAllowRepeatEmail: false,
  checkoutSelectedSub: {},
};

export const getCheckoutData = createAsyncThunk(
  "checkout/getCheckoutData",
  async (args, thunkAPI) => {
    const { pageSize, pageNumber, search, eventId } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/subscriptions`,
        method: "get",
        params: {
          pageSize,
          pageNumber,
          searchQuery: search,
        },
      });
      return { data: response };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los cupones. Error: ",
        error.message
      );
    }
  }
);

export const createCheckout = createAsyncThunk(
  "checkout/createCheckout",
  async (data, thunkAPI) => {
    const { eventId, newSubData } = data;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/subscriptions`,
        method: "post",
        data: newSubData,
      });
      return { data: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar las suscripciones. Error: ",
        error.message
      );
    }
  }
);

export const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setFreeCheckout: (state, action) => {
      state.freeCheckout = action.payload;
    },
    setNewCustomFields: (state, action) => {
      const { customFields } = action.payload;

      state.customFieldsToCreate = customFields;
    },
    setCheckoutPayments: (state, action) => {
      state.paymentsSupported = action.payload;
    },
    addCustomSelect: (state, action) => {
      state.customFieldsSelectOptions = [
        ...state.customFieldsSelectOptions,
        action.payload,
      ];
    },
    setCustomSelectField: (state, action) => {
      const { fieldId, optionsNumber } = action.payload;

      const found = state.customFieldsSelectOptions.find(
        (thisSelect) => thisSelect.fieldId === fieldId
      );
      if (found) {
        found.optionsNumber = optionsNumber;
      }
    },
    removeCustomSelect: (state, action) => {
      const { fieldId } = action.payload;

      const newArray = state.customFieldsSelectOptions.filter(
        (thisSelect) => thisSelect.fieldId !== fieldId
      );
      state.customFieldsSelectOptions = newArray;
    },
    setSubscriptionStep: (state, action) => {
      state.checkoutSubscriptionStep = action.payload;
    },
    setCheckoutSubCustomFields: (state, action) => {
      state.checkoutSubscriptionCustomFields = action.payload;
    },
    setCheckoutSubPrices: (state, action) => {
      state.checkoutSubscriptionPrices = action.payload;
    },
    addCheckoutCustomSelect: (state, action) => {
      state.checkoutCustomFieldSelects = [
        ...state.checkoutCustomFieldSelects,
        action.payload,
      ];
    },
    setCheckoutCustomSelectField: (state, action) => {
      const { fieldId, optionsNumber } = action.payload;

      const found = state.checkoutCustomFieldSelects.find(
        (thisSelect) => thisSelect.fieldId === fieldId
      );
      if (found) {
        found.optionsNumber = optionsNumber;
      }
    },
    removeCheckoutCustomSelect: (state, action) => {
      const { fieldId } = action.payload;

      const newArray = state.checkoutCustomFieldSelects.filter(
        (thisSelect) => thisSelect.fieldId !== fieldId
      );
      state.checkoutCustomFieldSelects = newArray;
    },
    addSubscriptionToAdd: (state, action) => {
      const { subscriptionItem } = action.payload;
      state.subscriptionsToCreate = [
        ...state.subscriptionsToCreate,
        subscriptionItem,
      ];
    },
    updateSubscriptionToAdd: (state, action) => {
      const { subscriptionId, subscriptionItem } = action.payload;
      const subtoUpdate = state.subscriptionsToCreate.find(
        (thisSub) => thisSub.id === subscriptionId
      );
      if (subtoUpdate) {
        subtoUpdate = subscriptionItem;
      }
    },
    removeSubscriptionToAdd: (state, action) => {
      const newSubscriptions = state.subscriptionsToCreate.filter(
        (subItem) => subItem.id !== action.payload
      );
      state.subscriptionsToCreate = [...newSubscriptions];
    },
    clearSubscriptionsToAdd: (state) => {
      state.subscriptionsToCreate = [];
    },
    setSelectedSubscription: (state, action) => {
      state.checkoutSelectedSub = action.payload;
    },
    setAllowingRepeatEmail: (state, action) => {
      state.checkoutAllowRepeatEmail = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCheckoutData.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.list = data.data;
        state.loadingStatus = "succeeded";
      })
      .addCase(getCheckoutData.rejected, (state) => {
        state.loadingStatus = "failed";
      })
      .addCase(createCheckout.fulfilled, (state, action) => { })
      .addCase(createCheckout.rejected, (state) => {
        state.loadingStatus = "failed";
      });
  },
});

export const {
  setFreeCheckout,
  addCustomSelect,
  setNewCustomFields,
  removeCustomSelect,
  setCheckoutPayments,
  setSubscriptionStep,
  setCheckoutSubPrices,
  setCustomSelectField,
  addSubscriptionToAdd,
  setAllowingRepeatEmail,
  addCheckoutCustomSelect,
  updateSubscriptionToAdd,
  removeSubscriptionToAdd,
  clearSubscriptionsToAdd,
  setSelectedSubscription,
  setCheckoutSubCustomFields,
  removeCheckoutCustomSelect,
  setCheckoutCustomSelectField,
} = checkoutSlice.actions;
export default checkoutSlice.reducer;

const customFields = [
  {
    id: "3b10ed40-bd6f-4495-7069-08da94851c82",
    displayName: "Correo Electrónico Alternativo",
    formattedName: "correo_alternativo",
    type: "textfield",
    helperText: null,
    options: "",
    number: false,
    priority: 1,
    required: false,
    validate: false,
    maxLength: 0,
    minLength: 0,
    translations: [
      {
        id: "52de4b3d-3504-4c5e-610b-08da94851c86",
        displayName: "Correo Electrónico Alternativo",
        helperText: null,
        locale: "es-MX",
      },
    ],
  },
];
